export const features = [
  {
    title: 'Industry Experts',
    description: 'Learn from professionals with real-world experience at top tech companies',
    icon: '👨‍💼'
  },
  {
    title: 'Hands-on Projects',
    description: 'Build real projects that you can showcase in your portfolio',
    icon: '🛠️'
  },
  {
    title: 'Career Support',
    description: 'Get help with job placement and career guidance',
    icon: '🎯'
  },
  {
    title: 'Certification',
    description: 'Earn industry-recognized certificates upon completion',
    icon: '🏆'
  }
];